/* eslint-disable */
import axios from 'axios';
import { Toast } from 'bootstrap';
import { Network } from 'ethers';
import { createStore } from 'vuex'

const PATH_API = process.env.VUE_APP_API_SERVER;

const api = axios.create({
  baseURL: PATH_API,
  withCredentials: false,
  timeout: 180000
});

api.interceptors.response.use(function (response) {
  if (response.headers['x-xsrf-token']) {
    console.log('x-xsrf-token', response.headers['x-xsrf-token'])
    document.cookie = 'XSRF-TOKEN=' + response.headers['x-xsrf-token'] + '; path=/';
  }
  return response;
});

const SombreroAPI = {
  newNotification({ type, title, message }) {
    const toastElement = document.createElement('div');
    toastElement.classList.add('toast', 'align-items-center', `text-bg-${type}`, 'border-0');
    toastElement.setAttribute('role', 'alert');
    toastElement.setAttribute('aria-live', 'assertive');
    toastElement.setAttribute('aria-atomic', 'true');
    
    toastElement.innerHTML = `
      <div class="d-flex">
        <div class="toast-body">
          <strong>${title}</strong>
          <br>${message}
        </div>
        <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
    `;

    document.getElementById('toast-container').appendChild(toastElement);

    const bootstrapToast = new Toast(toastElement, { delay: 3000 });
    bootstrapToast.show();

    // Eliminar el toast cuando se oculte
    toastElement.addEventListener('hidden.bs.toast', () => {
      toastElement.remove();
    });
  },

  _ResponseIsError(data) {
    console.log('_ResponseIsError', data)
    if (data.code != undefined) {
      const title = data.details != undefined ? data.message : "Error " + data.code;
      const message = data.details != undefined ? data.details : data.message;
      this.newNotification({
        type: 'danger',
        title: title,
        message: message,
      })
    }
    else {
      this.newNotification({
        type: 'danger',
        title: 'Error no identificado',
        // message: data.message,
      })
    }
  },

  async _postNoErrorAPI(path, params=null) {
    const rawResponse = await fetch(PATH_API + path, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    });
    const content = await rawResponse.json();
    if (content.id != undefined) return content;
    // this._ResponseIsError(content)
    return "error";
  },

  async _postNoError(path, params) {
    return await api.post(path, params)
      .then(r => {
        return r.data;
      })
      .catch(e => {
        const { data } = e.response;
        console.log('e:data', data)
        // this._ResponseIsError(data)
        return "error";
      })
  },

  async _post(path, params) {
    return await api.post(path, params)
      .then(r => {
        return r.data;
      })
      .catch(e => {
        const { data } = e.response;
        console.log('e:data', data)
        this._ResponseIsError(data)
        return "error";
      })
  },

  async _postFetch(path, params = null) {
    try {
      const rawResponse = await fetch(PATH_API + path, {
        method: 'POST',
        credentials: 'same-origin', // Incluye cookies automáticamente
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          // Incluye el token CSRF si existe en las cookies
          'X-XSRF-TOKEN': document.cookie
            .split('; ')
            .find((row) => row.startsWith('XSRF-TOKEN='))
            ?.split('=')[1] || '',
        },
        body: JSON.stringify(params),
      });
  
      // Verifica si la respuesta fue exitosa (código HTTP 2xx)
      if (!rawResponse.ok) {
        const errorData = await rawResponse.json();
        console.log('Error data:', errorData);
        this._ResponseIsError(errorData);
        return "error";
      }
  
      // Si existe un token XSRF en los encabezados, guárdalo en las cookies
      const xsrfToken = rawResponse.headers.get('x-xsrf-token');
      console.log('rawResponse.xsrfToken', xsrfToken)
      if (xsrfToken) {
        console.log('x-xsrf-token:', xsrfToken);
        document.cookie = `XSRF-TOKEN=${xsrfToken}; path=/`;
      }
  
      // Devuelve el contenido en JSON si todo salió bien
      const content = await rawResponse.json();
      return content;
    } catch (error) {
      console.error('Network error:', error);
      this._ResponseIsError({ message: error.message });
      return "error";
    }
  },
  
  async _get(path, params=null) {
    return await api.get(path, {
      params: params
    })
      .then(r => {
        return r.data;
      })
      .catch(e => {
        const { data } = e.response;
        console.log('e:data', data)
        this._ResponseIsError(data)
        return "error";
      })
  },
  
  async _proccessResponse(response=null) {
    if (response != null) {
      console.log('procesando response')
      console.log('response', response)
    }
  },

  async v1_login({ email, password }) {
    const login = await SombreroAPI._post('/v1/auth/login', { email, password })
    let res = {
      status: 'unknown',
      authResponse: {
        accessToken: null,
        expiresIn: Math.floor(Date.now() / 1000),
        reauthorize_required_in: Math.floor(Date.now() / 1000),
        userID: 0
      },
      userData: null,
      balance: 0,
      last: [],
    }
    if (login == 'error') {
      res.status = 'not_authorized'
    } else {
      if (login.result == true) {
        console.log('isLogin', login)
        res.status = 'connected'
        res.authResponse.userID = login.user.id
        res.userData = login.user
        res.balance = login.balance
        res.last = login.last
      }
    }
    return res;
  },

  async v1_register({ username, email, password }) {
    const res = await SombreroAPI._post('/v1/auth/register', { username, email, password })
    if (res == 'error') {
      return false;
    } else {
      return true;
    }
  },
  
  async v1_sendValidateUser({ username, email, key }) {
    const response = await SombreroAPI._post('/v1/auth/send-validate', { username, email, key })
    if (response == 'error') {
      return false;
    } else {
      return true;
    }
  },
  
  async v1_validateUser({ username, email, key }) {
    const res = await SombreroAPI._post('/v1/auth/validate', { username, email, key })
    if (res == 'error') {
      return false;
    } else {
      // location.reload()
      return true;
    }
  },

  async v1_requestSell({ network_id, asset_id, amount, time_lock }) {
    const response = await SombreroAPI._post('/v1/verify/blocking', { network_id, asset_id, amount, time_lock })
    if (response == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async requestSell({ asset, amount, time_lock }) {
    console.log('requestSell:data:', asset, amount)
    const response = await SombreroAPI._post('/crypto/blocking', { asset, amount, time_lock })
    console.log('requestSell:response', response)
    if (response == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async v1_createWallet({ mnemonic,address,private_key,path,index,chainId }) {
    const validate_wallet = await SombreroAPI._post('/v1/auth/validate-wallet', { mnemonic,address,private_key,path,index,chainId })
    if (validate_wallet == 'error') {
      return false;
    } else {
      // location.reload()
      return true;
    }
  },

  async validateWallet({ mnemonic }) {
    console.log('validateWallet:data:', mnemonic)
    const validate_wallet = await SombreroAPI._post('/auth/validate-wallet', { mnemonic })
    console.log('validateUser:validate_wallet', validate_wallet)
    if (validate_wallet == 'error') {
      return false;
    } else {
      // location.reload()
      return true;
    }
  },

  async v1_recoveryUser({ email }) {
    const validateUser = await SombreroAPI._post('/v1/auth/recovery', { email })
    if (validateUser == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async logout() {
    console.log('logout:')
    const logout = await SombreroAPI._post('/v1/auth/logout')
    console.log('logout:logout', logout)
    return logout;
  },

  async getNetworksDeposit() {
    return await SombreroAPI._get('/networks/deposit')
  },

  async getNetworksBalances() {
    return await SombreroAPI._get('/networks/balances');
  },

  async getNetworksWithdraw() {
    return await SombreroAPI._get('/networks/withdraw');
  },

  async getAssetsBlocking() {
    return await SombreroAPI._get('/assets/blocking');
  },

  async v1_getAssets() {
    return await SombreroAPI._get('/v1/assets')
  },

  async v1_getLastLocked() {
    return await SombreroAPI._get('/v1/last/locked')
  },

  async getAssets() {
    console.log('assets:')
    const assets = await SombreroAPI._get('/list/assets')
    console.log('assets:assets', assets)
    return assets;
  },

  async v1_getHistoryById({ tx_id }) {
    const record = await SombreroAPI._post('/v1/history/view', { tx_id })
    if (record == 'error') {
      this.newNotification({
        type: 'danger',
        title: 'Error',
        message: record.message,
      })
      return null;
    } else {
      return record;
    }
  },

  async v1_getTransactionById({ tx_id }) {
    const record = await SombreroAPI._post('/v1/transactions/view', { tx_id })
    if (record == 'error') {
      this.newNotification({
        type: 'danger',
        title: 'Error',
        message: record.message,
      })
      return null;
    } else {
      return record;
    }
  },

  async v1_runCancelTx({ tx_id }) {
    const record = await SombreroAPI._post('/v1/canceled/tx-blocking', { tx_id })
    if (record == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async runWithdrawTx({ tx_id }) {
    const record = await SombreroAPI._post('/v1/withdraw/tx-blocking', { tx_id })
    console.log('runWithdrawTx:record', record)
    if (record == 'error') {
      // this.newNotification({
      //   type: 'danger',
      //   title: 'Error',
      //   message: record.message,
      // })
      return false;
    } else {
      return true;
    }
  },

  async v1_sendTxInternal({ network_id, asset_id, wallet_dst, amount }) {
    const record = await SombreroAPI._post('/v1/verify/txinternal', { network_id, asset_id, wallet_dst, amount })
    if (record == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async v1_withdrawExternal({ network_id, asset_id, wallet_dst, amount }) {
    const record = await SombreroAPI._post('/v1/verify/withdraw', { network_id, asset_id, wallet_dst, amount })
    if (record == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async withdrawExternal({ asset_id, to, amount }) {
    const record = await SombreroAPI._post('/verify/withdraw', { asset_id, to, amount })
    console.log('withdrawExternal:record', record)
    if (record == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async v1_getHistoryListAll() {
    return await SombreroAPI._get('/v1/history/list', {
      'limit': -1,
    })
  },

  async v1_getHistoryList() {
    return await SombreroAPI._get('/v1/history/list')
  },

  async getTransactionList() {
    console.log('getTransactionList:')
    return await SombreroAPI._get('/transactions/list')
  },

  async getCurrencies() {
    console.log('currencies:')
    const currencies = await SombreroAPI._get('/list/currencies')
    console.log('currencies:currencies', currencies)
    return currencies;
  },

  async requestSMS() {
    console.log('requestSMS:')
    const res = await SombreroAPI._post('/validate/request/sms')
    console.log('requestSMS:res', res)
    if (res == 'error') {
      return false;
    } else {
      this.newNotification({
        type: 'success',
        title: 'Exito',
        message: res.message,
      })
      return true;
    }
  },

  async upMobile(mobile) {
    console.log('upMobile:', mobile)
    const res = await SombreroAPI._post('/config/mobile', {mobile:mobile})
    console.log('upMobile:res', res)
    if (res == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async validateFA2(code) {
    console.log('validateFA2:', code)
    const res = await SombreroAPI._post('/validate/fa2', {code:code})
    console.log('validateFA2:res', res)
    if (res == 'error') {
      return false;
    } else {
      // this.newNotification({
      //   type: 'success',
      //   title: 'Exito ----------',
      //   // message: res.message,
      // })
      return res;
    }
  },

  async verifyFA2({ code }) {
    console.log('verifyFA2:', code)
    const res = await SombreroAPI._post('/verify/fa2', { code })
    console.log('verifyFA2:res', res)
    if (res == 'error') {
      return false;
    } else {
      // this.newNotification({
      //   type: 'success',
      //   title: 'Exito ----------',
      //   // message: res.message,
      // })
      return res;
    }
  },

  async validateMobile(code) {
    console.log('validateMobile:', code)
    const res = await SombreroAPI._post('/validate/mobile', {code:code})
    console.log('validateMobile:res', res)
    if (res == 'error') {
      return false;
    } else {
      this.newNotification({
        type: 'success',
        title: 'Exito',
        message: res.message,
      })
      return true;
    }
  },

  async v1_changePassword({ password, new_password }) {
    const res = await SombreroAPI._post('/v1/auth/change-password', { password, new_password })
    if (res == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async v1_verifyDeposit({ network, asset }) {
    const res = await SombreroAPI._post('/v1/verify/deposit', {network_id: network, asset_id: asset})
    if (res == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async verifyDeposit({ network, asset }) {
    const res = await SombreroAPI._post('/verify/deposit', {network_id: network, asset_id: asset})
    if (res == 'error') {
      return false;
    } else {
      return true;
    }
  },

  async v1_checkSession() {
    const checkUser = await SombreroAPI._postNoError('/v1/auth/comprobe')
    let res = {
      status: 'unknown',
      authResponse: {
        accessToken: null,
        expiresIn: Math.floor(Date.now() / 1000),
        reauthorize_required_in: Math.floor(Date.now() / 1000),
        // signedRequest:'{signed-parameter}',
        userID: 0
      },
      userData: null,
      balance: 0,
      last: [],
    };

    if (checkUser == 'error') {
      res.status = 'not_authorized'
    } else {
      console.log('isIser', checkUser)
      res.status = 'connected'
      res.authResponse.userID = checkUser.user.id
      res.userData = checkUser.user
      res.balance = checkUser.balance
      res.last = checkUser.last
    }
    return res;
  },
};

export default createStore({
  state: {
    loading: true,
    status: 'unknown',
    authResponse: {
      accessToken: null,
      expiresIn: null,
      reauthorize_required_in: null,
      // signedRequest:'{signed-parameter}',
      userID: 0
    },
    userData: null,
    balance: 0,
    portfolio: [],
    last: [],
    networks: {
      balances: [],
      deposit: [],
    },
    currencies: [],
    assets: {
      blocking: [],
    },
  },
  getters: {
    // isLoading(state) {
    //   return state.loading || state.status === 'unknown' || state.networks.deposit.length == 0 || state.networks.balances.length == 0 || state.currencies.length == 0;
    // },
    isLoading(state) {
      return state.loading || state.status === 'unknown' || state.portfolio.length == 0;
    },
    isAuthenticated(state) {
      return state.status == 'conneted' && state.authResponse.userID > 0;
    },
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setStatus(state, value) {
      state.status = value;
    },
    setAuthResponse(state, value) {
      state.authResponse = value;
    },
    setUserData(state, value) {
      state.userData = value;
    },
    setUserBalance(state, value) {
      state.balance = value;
    },
    setUserLast(state, value) {
      state.last = value;
    },
    setNetworksBalances(state, value) {
      state.networks.balances = value;
    },
    setNetworksDeposit(state, value) {
      state.networks.deposit = value;
    },
    setNetworksWithdraw(state, value) {
      state.networks.withdraw = value;
    },
    setCurrencies(state, value) {
      state.currencies = value;
    },
    setPortfolio(state, value) {
      state.portfolio = value;
    },
    // AQUIIII
    setAssetsBlocking(state, value) {
      state.assets.blocking = value;
    },
  },
  actions: {
    async loadCurrencies({ state, commit }) {
      const currencies = await SombreroAPI.getCurrencies()
      console.log('currencies', currencies)
      commit('setCurrencies', currencies.currencies)
      return true;
    },
    async loadNetworks({ state, commit }) {
      // const nBalances = await SombreroAPI.getNetworksBalances()
      // const nDeposit = await SombreroAPI.getNetworksDeposit()
      // const nWithdraw = await SombreroAPI.getNetworksWithdraw()
      // const aBlocking = await SombreroAPI.getAssetsBlocking()
      const v1_assets = await SombreroAPI.v1_getAssets()
      // console.log('nBalances', nBalances)
      // console.log('nDeposit', nDeposit)
      // console.log('nWithdraw', nWithdraw)
      // console.log('aBlocking', aBlocking)
      // commit('setNetworksBalances', nBalances.networks)
      // commit('setNetworksDeposit', nDeposit.networks)
      // commit('setNetworksWithdraw', nWithdraw.networks)
      // commit('setAssetsBlocking', aBlocking.assets)
      commit('setPortfolio', v1_assets)
      console.log('v1_assets', v1_assets)
      return true;
    },
    async checkSession({ state, commit }) {
      const checkSession = await SombreroAPI.v1_checkSession()
      if (state.loading == true) {
        commit('setStatus', checkSession.status)
        commit('setAuthResponse', checkSession.authResponse)
        commit('setLoading', false)
        commit('setUserData', checkSession.userData)
        commit('setUserBalance', checkSession.balance)
        commit('setUserLast', checkSession.last)
      }
      return checkSession;
    },
    // eslint-disable-next-line
    async v1_registerAPI({}, {username, email, password}) {
      const register = await SombreroAPI.v1_register({ username, email, password })
      if (register == true) {
        SombreroAPI.newNotification({
          type: 'success',
          title: 'registrado con exito',
          message: "Se creo tu cuenta con exito, verifica tu correo.",
        })
        // location.reload()
      } else {
        SombreroAPI.newNotification({
          type: 'danger',
          title: 'Error en registro',
          message: "Hubo un error registrandose.",
        })
      }
      return register;
    },
    // eslint-disable-next-line
    async v1_loginAPI({}, {email, password}) {
      const login = await SombreroAPI.v1_login({ email, password })
      if (login.status == 'connected') {
        SombreroAPI.newNotification({
          type: 'success',
          title: 'Autenticado con exito',
          message: "Tu acceso fue verificado con exito.",
        })
      }
      else if (login.status == 'not_authorized') {
        // SombreroAPI.newNotification({
        //   type: 'danger',
        //   title: 'Autenticado fallida',
        //   message: "Tu acceso no fue verificado.",
        // })
      }

      return login;
    },
    async v1_verifyDeposit({ state }, { network, asset }) {
      console.log('v1_verifyDeposit', network, asset)
      // const item = state.portfolio[asset].networks_recharge[network].src
      // console.log('item', item)
      return await SombreroAPI.v1_verifyDeposit({ network, asset })
    },

    // eslint-disable-next-line
    async v1_sendValidateAPI({}, {username,email,key}) {
      const res = await SombreroAPI.v1_sendValidateUser({ username,email,key })
      if (res == true) {
        SombreroAPI.newNotification({
          type: 'success',
          title: 'Exito',
          message: "Correo enviado con exito, ahora todo depende del usuario.",
        })
      } else {
        SombreroAPI.newNotification({
          type: 'danger',
          title: 'Error',
          message: "Error enviando el correo de verificacion.",
        })
      }
      return res;
    },

    // eslint-disable-next-line
    async v1_validateAPI({}, {username,email,key}) {
      const res = await SombreroAPI.v1_validateUser({ username,email,key })
      if (res == true) {
        SombreroAPI.newNotification({
          type: 'success',
          title: 'Cuenta comprobada',
          message: "Se valido tu usuario con exito ahora puedes ingresar sesion.",
        })
      }
      return res;
    },
    // eslint-disable-next-line
    async v1_createSellAPI({}, { network_id, asset_id, amount, time_lock }) {
      return await SombreroAPI.v1_requestSell({ network_id, asset_id, amount, time_lock })
    },
    // eslint-disable-next-line
    async createSellAPI({}, { asset, amount, time_lock }) {
      console.log('asset, amount', asset, amount)
      return await SombreroAPI.requestSell({ asset, amount, time_lock })
    },
    // eslint-disable-next-line
    async verifyFA2API({}, { code }) {
      const response = await SombreroAPI.verifyFA2({ code })
      console.log('verifyFA2API:response', response)
      if (response == true) {
        SombreroAPI.newNotification({
          type: 'success',
          title: '-----verifyFA2API----',
          message: "-----verifyFA2API--------",
        })
      }
      return response;
    },
    // eslint-disable-next-line
    async validateFA2API({}, {}) {
      const response = await SombreroAPI.validateFA2({})
      console.log('validateFA2API:response', response)
      if (response == true) {
        SombreroAPI.newNotification({
          type: 'success',
          title: '-----validateFA2API----',
          message: "----validateFA2API---------",
        })
      }
      return response;
    },
    // eslint-disable-next-line
    async v1_createWalletFullAPI({}, { mnemonic,address,private_key }) {
      const response = await SombreroAPI.v1_createWallet({ mnemonic,address,private_key })
      if (response == true) {
        SombreroAPI.newNotification({
          type: 'success',
          title: 'Billetera creada',
          message: "Se creo la billetera correctamente.",
        })
      }
      return response;
    },
    // eslint-disable-next-line
    async createWalletAPI({}, {mnemonic}) {
      const response = await SombreroAPI.validateWallet({ mnemonic })
      console.log('createWalletAPI:response', response)
      if (response == true) {
        SombreroAPI.newNotification({
          type: 'success',
          title: 'Billetera creada',
          message: "Se creo la billetera correctamente.",
        })
      }
      return response;
    },
    // eslint-disable-next-line
    async v1_recoveryAPI({}, {email}) {
      const recovery = await SombreroAPI.v1_recoveryUser({ email })
      if (recovery == true) {
        SombreroAPI.newNotification({
          type: 'success',
          title: 'Clave cambiada con exito',
          message: "Se envio un correo con la nueva contraseña.",
        })
      }
      return recovery;
    },
    // eslint-disable-next-line
    async logoutAPI() {
      const abc = await SombreroAPI.logout()
      return abc, location.reload();
    },

    async networksBalancesAPI() {
      return await SombreroAPI.getNetworksBalances()
    },
    async networksDepositAPI() {
      return await SombreroAPI.getNetworksDeposit()
    },
    async networksWithdrawAPI() {
      return await SombreroAPI.getNetworksWithdraw()
    },
    async assetsAPI() {
      return await SombreroAPI.getAssets()
    },
    async currenciesAPI() {
      return await SombreroAPI.getCurrencies()
    },
    // eslint-disable-next-line
    async v1_updatePasswordAPI({}, { password, new_password }) {
      console.log('updatePasswordAPI', password, new_password)
      return await SombreroAPI.v1_changePassword({ password, new_password })
    },
    // eslint-disable-next-line
    async verifyDepositAPI({}, { network, asset }) {
      console.log('verifyDepositAPI', network, asset)
      return await SombreroAPI.verifyDeposit({ network, asset })
    },
    // eslint-disable-next-line
    async configMobile({}, mobile) {
      console.log('configMobile:mobile', mobile)
      return await SombreroAPI.upMobile(mobile)
    },
    // eslint-disable-next-line
    async validateMobileAPI({}, code) {
      console.log('validateMobileAPI:code', code)
      return await SombreroAPI.validateMobile(code)
    },
    async requestSMSAPI() {
      return await SombreroAPI.requestSMS()
    },
    // eslint-disable-next-line
    async newNotification({}, { type, title, message }) {
      return SombreroAPI.newNotification({ type, title, message }); 
    },
    async v1_historyListAll() {
      return SombreroAPI.v1_getHistoryListAll(); 
    },
    async v1_historyList() {
      return SombreroAPI.v1_getHistoryList(); 
    },
    async transactionsList() {
      return SombreroAPI.getTransactionList(); 
    },
    // eslint-disable-next-line
    async v1_historyView({}, { tx_id }) {
      return SombreroAPI.v1_getHistoryById({ tx_id }); 
    },
    // eslint-disable-next-line
    async v1_transactionsView({}, { tx_id }) {
      return SombreroAPI.v1_getTransactionById({ tx_id }); 
    },
    // eslint-disable-next-line
    async withdrawTx({}, { tx_id }) {
      return SombreroAPI.runWithdrawTx({ tx_id }); 
    },
    // eslint-disable-next-line
    async v1_cancelTx({}, { tx_id }) {
      return SombreroAPI.v1_runCancelTx({ tx_id }); 
    },
    // eslint-disable-next-line
    async withdrawExternal({}, { asset_id, to, amount }) {
      return SombreroAPI.withdrawExternal({ asset_id, to, amount }); 
    },
    // eslint-disable-next-line
    async v1_withdrawExternal({}, { network_id, asset_id, wallet_dst, amount }) {
      return SombreroAPI.v1_withdrawExternal({ network_id, asset_id, wallet_dst, amount }); 
    },
    
    // eslint-disable-next-line
    async v1_sendTxInternal({}, { network_id, asset_id, wallet_dst, amount }) {
      return SombreroAPI.v1_sendTxInternal({ network_id, asset_id, wallet_dst, amount }); 
    },
    
    // eslint-disable-next-line
    async v1_getLastLocked() {
      return SombreroAPI.v1_getLastLocked(); 
    },
    
    // eslint-disable-next-line
    async getChainlist() {
      return await axios.get("https://chainid.network/chains.json", {
        params: {}
      })
      .then(r => {
        console.log('r', r)
        return r.data;
      })
      .catch(e => {
        const { data } = e.response;
        console.log('e:data', data)
        this._ResponseIsError(data)
        return "error";
      })
      .finally(() => {
        return [];
      })
    },
    
    async getPortfolio() {
      return await SombreroAPI.v1_getAssets(); 
    },
  },
  modules: {
  }
})
